var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row header mb-3" }, [
    _c("div", { staticClass: "col-9" }, [
      _c("h2", { staticClass: "page-header pendo--badge-target-wrapper" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$tc("drip-campaigns.dripCampaign", 2)) +
            "\n      "
        ),
        _c(
          "span",
          { attrs: { id: "drip-campaign-tooltip" } },
          [
            _c("icon", {
              staticClass: "tooltip-info",
              attrs: { name: "question-circle" },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-3 forward" }, [
      _c("div", { staticClass: "d-flex flex-row client justify-content-end" }, [
        _c(
          "div",
          { staticClass: "p-0 d-none d-lg-flex flex-row button-wrapper" },
          [
            _c(
              "plan-tooltip",
              {
                attrs: {
                  page: _vm.currentPagePlan,
                  disabled: !_vm.IS_USAGE_RESTRICTED(_vm.currentPagePlan),
                },
              },
              [
                _c(
                  "simple-button",
                  {
                    attrs: {
                      disabled: _vm.IS_USAGE_RESTRICTED(_vm.currentPagePlan),
                    },
                    on: { click: _vm.handleCreateDripCampaign },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("drip-campaigns.actions.createCampaign")
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dropleft position-static" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu" }, [
            _c("div", { staticClass: "dropdown-item clickable wide" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm text-danger",
                  class: {
                    disabled: _vm.IS_USAGE_RESTRICTED(_vm.currentPagePlan),
                  },
                  attrs: { type: "button" },
                  on: { click: _vm.handleCreateDripCampaign },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("drip-campaigns.actions.createCampaign")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-9" }, [
      _c("h6", { staticClass: "grey-text text-darken-1" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("drip-campaigns.subtitle")) + "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-lg-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }